import { fetchFamilies } from '@gn-audio/core/api/product-catalogue/fetch-families';
import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { Component, Inject, OnInit } from 'angular-ts-decorators';
import {
  CompareCheckboxAction,
  ICompareCheckboxService,
  INotficationItem,
} from 'src/Foundation/Design/platform';

import template from './compare-basket.component.html';

@Component({
  selector: 'compareBasket',
  template,
})
export class CompareBasketComponent implements OnInit {
  public static $inject: ReadonlyArray<string> = [];

  public products: IFamily[] = [];
  public isFull = false;
  public isCollapsed = true;

  constructor(
    @Inject('$q') private $q: ng.IQService,
    @Inject('$log') private $log: ng.ILogService,
    @Inject('compareCheckboxService')
    private compareCheckboxService: ICompareCheckboxService
  ) {}

  public ngOnInit(): void {
    this.getFamilies(this.productIds);
    this.compareCheckboxService
      .subscribe()
      .then(null, null, this.handleProductIdsChange.bind(this));
  }

  public get productIds(): number[] {
    return this.compareCheckboxService.idsToCompare;
  }

  public get isVisible(): boolean {
    return this.isComparePage() ? false : this.hasProducts();
  }

  public onToggle() {
    this.isCollapsed = !this.isCollapsed;
  }

  private handleProductIdsChange(notification: INotficationItem): void {
    if (this.productIds.length === 0) {
      this.products = [];
    } else {
      const action = notification.action;
      const id = notification.id;
      this.isFull = false;

      switch (action) {
        case CompareCheckboxAction.Added:
          this.getFamilies([notification.id]);
          break;

        case CompareCheckboxAction.Removed:
          this.products.splice(this.indexOf(id), 1);
          break;

        case CompareCheckboxAction.IsFull:
          this.isFull = true;
      }
    }
  }

  private getFamilies(productIds: number[]): ng.IPromise<any> | undefined {
    if (productIds?.length === 0) {
      return;
    }

    this.$q
      .when(fetchFamilies(productIds))
      .then((families: IFamily[] | null) => {
        if (!families) {
          this.$log.warn(`Did not manage to load families: ${productIds}`);
        }
        (families || []).forEach((f: IFamily) => {
          this.products.push(f);
        });
      });
  }

  private indexOf(id: number): number {
    let productIndex = -1;

    for (let i = 0; i < this.products.length; i++) {
      const product = this.products[i];
      if (product.familyId === id) {
        productIndex = i;
        break;
      }
    }

    return productIndex;
  }

  private isComparePage(): boolean {
    return location.pathname === '/compare-products';
  }

  private hasProducts(): boolean {
    return this.products?.length > 0;
  }
}
